import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { CaptchaComponent } from 'angular-captcha';
import { ContactoService } from '../_services';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css'],
  inputs: ['incrustado', 'nombre']
})
export class ContactoComponent implements OnInit {
  contactoForm: FormGroup;
  submitted = false;
  loading = false;
  alerta = '';
  incrustado: boolean = false;
  nombre: string = '';
  @ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent;

  constructor(
    private formBuilder: FormBuilder,
    private contactoService: ContactoService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  get f() {
    return this.contactoForm.controls;
  }
  ngOnInit() {
    this.contactoForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      comment: [''],
      captchaCode: [''],
      captchaId: ['']
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.contactoForm.invalid) {
      return;
    }
    this.loading = true;
    this.contactoForm.controls.captchaCode.setValue(
      this.captchaComponent.captchaCode
    );
    this.contactoForm.controls.captchaId.setValue(
      this.captchaComponent.captchaId
    );
    this.contactoService
      .postContacto(this.contactoForm.value)
      .pipe(first())
      .subscribe(
        data => {
          console.log('Mail enviado exitosamente');
          this.submitted = true;
          this.loading = false;
          this.alerta = '';
          // reload Captcha image
          this.captchaComponent.reloadImage();
          alert('Se envió exitosamente el correo de contacto.');
          this.router.navigate(['/inicio']);
        },
        error => {
          console.error(error);
          this.alerta = error;
          this.loading = false;
          this.submitted = false;
          // reload Captcha image
          this.captchaComponent.reloadImage();
        }
      );
  }

  onClosed(dismissedAlert: any): void {
    this.alerta = '';
  }
}
